import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { useNavigate } from 'react-router-dom';
import { Button, InputField, TableWrapper } from 'components/Global';
import { ReactComponent as ReviewDetailIcon } from 'icons/review-detail-filled-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getReviewById, sendReviewReply } from 'features/reviews/actions';
import { ReactComponent as Star } from 'icons/star.svg';
import { useAppContext } from 'components/Context/AppContext';
import { trackEvent } from 'utils/analytics';
import { getOrderType } from '..';

const ReviewDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { showToast } = useAppContext();

  const review = useSelector((state) => state.reviews.byId);

  const [value, setValue] = useState('');
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    dispatch(getReviewById(id));
  }, [id]);

  const lastReplies =
    Array.isArray(review.replies) && review.replies.length ? review.replies[review.replies.length - 1] : '';

  useEffect(() => {
    setValue(lastReplies.message);

    if (!lastReplies) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [lastReplies]);

  const handleSendReply = async () => {
    if (!value || value.trim() === '') return;

    try {
      trackEvent('review_replied', {
        review_id: Number(id),
        source: 'review_detail',
      });
      await dispatch(sendReviewReply({ review_id: Number(id), message: value })).unwrap();
      setIsEdit(false);
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal membalas review' });
    }
  };

  const canType = (review.replies === null && isEdit) || (Array.isArray(review.replies) && isEdit);
  const showReviewReply = review?.order_type_id === 1;

  return (
    <div className="review-detail">
      <header className="detail-one-day-booking__header" onClick={() => navigate(-1)}>
        <LeftArrow />
        <p>Kembali</p>
      </header>

      <TableWrapper title="Review Detail" icon={<ReviewDetailIcon width="25px" height="25px" />}>
        <div className="review-detail__body">
          <form className="review-detail__form">
            <InputField
              type="text"
              htmlFor="nomor-order"
              label="Nomor Order"
              value={review.order_number ?? '-'}
              readOnly
              disable
            />

            <div className="review-detail__service-info">
              <InputField
                type="text"
                label="Jenis Layanan"
                htmlFor="jenis-layanan"
                value={getOrderType({ orderType: review.order_type_id, supportDriver: review.support_driver }) ?? '-'}
                readOnly
                disable
              />

              <div className="review-detail__rating-info-wrapper">
                <h3>Rating</h3>
                <div className="review-detail__rating-info">
                  <span className="star">
                    <Star color="#f1a33a" />
                  </span>
                  <span className="rating-value">{review.rating ?? '-'}</span>
                </div>
              </div>
            </div>

            <div className="review-detail__review-customer">
              <h3>Review</h3>
              <textarea name="user-comment" cols="30" rows="8" value={review.comment} readOnly disabled />
            </div>

            {showReviewReply ? (
              <div className="review-detail__reply-editor">
                <h3>Balasan Review</h3>
                <textarea
                  name="user-comment"
                  id=""
                  cols="30"
                  rows="10"
                  value={value}
                  // onChange={canType ? (e) => setValue(e.target.value) : undefined}
                  onChange={(e) => setValue(e.target.value)}
                  readOnly={!canType}
                  disabled={!canType}
                />

                {canType ? (
                  <Button
                    width={113}
                    height={47}
                    role="button"
                    type="button"
                    onClick={handleSendReply}
                    className="review-detail__send-button"
                  >
                    Kirim
                  </Button>
                ) : (
                  <Button
                    width={113}
                    height={47}
                    role="button"
                    type="button"
                    onClick={() => setIsEdit(true)}
                    className="review-detail__send-button"
                  >
                    Edit
                  </Button>
                )}
              </div>
            ) : null}
          </form>
        </div>
      </TableWrapper>
    </div>
  );
};

export default ReviewDetailPage;
